import { scriptsReducerConstants } from '../reducerConstant';

const initialState = {
  authorizedScripts: [],
  scriptsLoaded: false,
  scriptsFailedToLoad: false
};

const scriptsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case scriptsReducerConstants.FETCH_SCRIPTS:
      return {
        ...state,
        authorizedScripts: action.value,
        scriptsLoaded: true,
        scriptsFailedToLoad: false,
      };
    case scriptsReducerConstants.GET_AUTH_SCRIPTS_FAILURE:
    case scriptsReducerConstants.GET_AUTH_SCRIPTS_REQUEST:
      return {
        ...state,
        scriptsLoaded: false,
        authorizedScripts: [],
        scriptsFailedToLoad: true,
      };
    default:
      return state;
  }
};

export default scriptsReducer;
